module.exports = __webpack_public_path__ + "img/06ebb12.jpg";